<template>
  <section class="section mobile_div section_bg   first_page   ">
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <div class="container loading_div" v-if="is_load==false">
      <h2>{{ load_message }}</h2>
    </div>

    <div class="section_header  d-flex justify-content-center" v-if="is_load">
    <nav aria-label="breadcrumb" v-if="is_load" >
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link tag="a"  :to="'/project/'+project.last_id" >{{ project.name_project}}</router-link></li>

        <li class="breadcrumb-item active" aria-current="page">База знаний</li>
      </ol>
    </nav>
    </div>
    <div class="row pb-100 " v-if="is_load">

      <div class="  col-lg-8 col-md-8  col-12 order-2 order-md-first ">











        <div class=" " style="padding:0px;"
              v-for="post in posts"
              :key="post.last_id">
          <div class="section_header nocenter post_material_mini mt-2 mb-2">





            <div class="post_material_mini_content" @click="openArticle(post.last_id,project.last_id)">
              <editorjsrender   :blocks_json="post.short.blocks"></editorjsrender>
            </div>
            <div class="d-flex justify-content-between post_material_mini_bottom">
              <p><i class="fa fa-calendar-o"></i><small>&nbsp; {{ post.created_at }}</small></p>
            
            </div>


            <router-link class="btn " v-if="post.short.blocks.length!=post.content.blocks.length" :to="{name: 'one_article', params: {id:project.last_id, post_id: post.last_id }}"
            >
              Читать далее
            </router-link>
          </div>


        </div>



        <card class="col-12 section_header col-sm-12 mt-5 ml-1 " v-if="count>current">
          <div class="row " v-if="count>current">
            <button class="btn btn-default" @click="loadCategoryPosts()">Загрузить еще</button>

          </div>
        </card>









      </div>
      <div class="col-lg-4 col-md-4  col-12 mt-2 mb-2 section_black   order-sm-first order-md-2"  >
        <card class="section_black section_header nocenter">
<!--          <div class="row">-->

<!--            <span class="badge-info">{{ category.title }}</span>-->

<!--          </div>-->

          <div class="row form-group">
            <p>Поиск по базе знаний</p>
          </div>
          <div class="row form-group">

            <input type="text" class="form-control" v-model="search_string" placeholder="Введите название"/>
          </div>
          <div class="row form-group">
            <button class="btn" @click="searchArticles">Найти</button>
          </div>
          <ul class="nav navbar multi_struct " >
            <li>
              <router-link tag="a"  :to="{name: 'add_article',params:{'id':project.last_id}}">
                &#x1F4C4;  Новая статья
              </router-link>
            </li>
            <treeview v-if="all_posts.length>0"  v-for="article in all_posts" :key="article.last_id"   class="item"
                      :item="article"

                      @add-item="addArticle"></treeview>







          </ul>
        </card>
      </div>
    </div>
  </section>



</template>

<script>
import {eventBus} from "@/main";
import Editorjsrender from "@/models/Editorjsrender.vue";
import Api from "@/models/Api";
import Vue from "vue";
import TreeView from "../../../components/TreeView";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "ArticlesList",
  data: function () {
    return {
      background_header: "/img/header_bg.jpg",
      user: null,
      islogin: false,
      is_load:false,
      load_message:"Идет загрузка...",
      category:{},
      current: 0,
      search_string:'',
      count: 0,
      posts: [],
      pinned:[],
      image_url: null,
      project:null,
      all_posts:[],

    }
  },
  mounted() {
    var app = this;
    app.image_url = Vue.config.IMAGE_URL;
    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }


    });



    app.loadArticles();
  },
  methods: {
    openArticle(post_id,project_id){
      var app=this;
      app.$router.push({name: 'one_article', params: {id:project_id, post_id: post_id }});
    },
    setLoad(message="Идет загрузка"){
      var app=this;

      app.load_message=message;
      app.is_load=false;
    },
    disableLoad(){
      var app=this;

      app.load_message="Идет загрузка";
      app.is_load=true;
    },
    addArticle(item){
      var app=this;
      app.$router.push({name: 'add_article',params: {id: app.project.last_id, "parent_id":item.last_id}});
    },
    openProject( ){
      var app=this;

      let routeData = app.$router.resolve({name: 'project',params: {id: app.project.last_id, "rand": Math.random()}});
      window.open(routeData.href, '_self');
    },
    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },

    searchArticles(){
      var app = this;
      let id = app.$route.params.id;
      app.is_load=false;


      Api.loadProjectArticlesList(id,app.search_string,20, 0, function (data) {

     //   app.count = data.count;
      //  app.posts=[];
       // app.posts = app.posts.concat(data.posts);
        app.all_posts=data.all_posts;



      //  app.current = app.current + data.posts.length;

      //  app.project=data.project;

        app.is_load=true;

      //  app.background_header = app.image_url + data.category.background;


      })
    },
    loadArticles() {
      var app = this;
      let id = app.$route.params.id;


      Api.loadProjectArticlesList(id,app.search_string,20, app.current, function (data) {

        app.count = data.count;
        app.posts=[];
        app.posts = app.posts.concat(data.posts);
        app.all_posts=data.all_posts;



        app.current = app.current + data.posts.length;

        app.project=data.project;

          app.is_load=true;

        app.background_header = app.image_url + data.category.background;


      })
    },
    callWritePost() {
      var app=this;
      var params = {

        type: "post_new",
        blog_category_default:app.category.last_id,
        blog_category_row:app.category,
        is_project:false,
        modal_title: "Добавить пост",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Название вашего поста",
              "level": 2
            }
          }]
        }
      };
      if(app.category.project_id>0){
        params['is_project']=true;
        params

      }
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    }
  },
  components: {
    'editorjsrender': Editorjsrender,
    'treeview':TreeView,
    LoadingBlock
  }
}
</script>

<style scoped>

</style>